import {
    LogChannel,
    LogRole,
    LogUser,
} from "../../core/types.js";
import { DefaultEntityClient } from "../../core/api/EntityClient.js";
import { FilterOption } from "./types.js";

export type NamedEntity = FilterOption & {
    id: string;
    name?: string;
};

export async function loadMembersByIds(values: unknown): Promise<Map<string, LogUser>> {
    const ids = Array.isArray(values)
        ? values.map(String)
        : [];
    const users = await DefaultEntityClient.getMembers(ids);
    const map = new Map<string, LogUser>();

    for (const user of users)
        map.set(user.id, user);

    return map;
}

export function loadRoles(): Promise<LogRole[]> {
    return DefaultEntityClient.getRoles();
}

export function loadChannels(): Promise<LogChannel[]> {
    return DefaultEntityClient.getChannels();
}

export function searchByIdOrName<TOption extends NamedEntity>(options: TOption[], query: string): TOption[] {
    return options.filter((option) => (
        option.id === query
        || option.name?.toLowerCase().includes(query)
    ));
}

export async function unserializeNamedEntities<TOption extends NamedEntity>(
    values: unknown,
    loader: () => Promise<TOption[]>,
): Promise<Map<string, TOption>> {
    const ids = Array.isArray(values)
        ? values.map(String)
        : [];
    const options = await loader();
    const unserialized = new Map<string, TOption>();

    for (const id of ids) {
        const option = options.find((entry) => entry.id === id);

        if (option)
            unserialized.set(id, option);
    }

    return unserialized;
}
